"use strict";
/**************************************************************************************************
 *
 *       @file data-manager.ts
 *
 *       Applies typings to DataManager object bundled in transpiled Javelin output.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
/************************************** THIRD-PARTY MODULES ***************************************/
var shared_1 = require("mad-utils/lib/shared");
var util_1 = require("util");
var javelin_exports_1 = require("../../javelin-exports");
/******************************************** LOGGING *********************************************/
var shared_2 = require("mad-logs/lib/shared");
var log = shared_2.logFactory('data-manager.ts', shared_2.Styles.rockIsDead, util_1.inspect);
/********************************* EXPORT DATA WITH TYPES APPLIED *********************************/
exports.DataManager = javelin_exports_1.javelin.data.util.manager.DataManager;
shared_1.defineProp(exports.DataManager.prototype, 'JVLN_CLASS_NAME', 'DataManager', false);
//# sourceMappingURL=data-manager.js.map